import moment from 'moment';

const HOURS_PER_DAY = 8;
const DAY_START_HOUR = 8;

// The one rule for how long a call runs: used when a card is dragged from Unscheduled onto the
// calendar and when a start date is picked on the time block form. A multi-day call works the same
// hours every day, so its end time is a full day's end time, and hours that don't fill the last
// day still take the whole day.
export const scheduleForWorkHours = ({work_hours, include_breaks, break_length}) => ({
    days: Math.ceil(work_hours / HOURS_PER_DAY),
    endHour: DAY_START_HOUR
        + Math.min(work_hours, HOURS_PER_DAY)
        + (include_breaks ? parseInt(break_length, 10) : 0),
});

// Inspections carry no skippedDays, so the drag counts Saturday and Sunday as work days.
// This does the same, otherwise the form and the calendar would disagree on the end date.
export const datesForWorkHours = (startDate, block) => {
    const { days, endHour } = scheduleForWorkHours(block);
    const start = moment(startDate).hour(DAY_START_HOUR).minute(0).second(0).millisecond(0);
    const end = start.clone().add(days - 1, 'days').hour(endHour);
    return {start, end};
};

// For a block that already has a start: the day runs from the start time actually on the form,
// which may not be 8 AM, and that day repeats through the last day.
export const endForStartTime = (startDate, startTime, block) => {
    const { days, endHour } = scheduleForWorkHours(block);
    return moment(startDate)
        .add(days - 1, 'days')
        .hour(endHour + startTime.hour() - DAY_START_HOUR)
        .minute(startTime.minute())
        .second(0)
        .millisecond(0);
};

// For the time block form's quick start buttons: same day, new start hour, end from the rule above.
export const datesForStartHour = (startDate, hour, block) => {
    const start = moment(startDate).hour(hour).minute(0).second(0).millisecond(0);
    return {start, end: endForStartTime(startDate, start, block)};
};
